import Config from "../config";

// Note: you may ask why we need this? Why not just use toLocaleString with the currency option? toLocaleString separates the currency shorthand (e.g. CHF) and the amount with a &nbsp; - and our font (Brandon Grotesqu) renders the &nbsp; as a high-comma (') at certain font-weights ... cute, ey?
function currency(amount, showCurrency, useDash) {
  let n = Number(amount).toLocaleString(Config.country === "ch" ? "de-CH" : "de-DE", {minimumFractionDigits:2, maximumFractionDigits:2});
  if(useDash) {
    if(Config.country === "ch") {
      n = n.replace(".00", ".-") // ch
    }
    if(Config.country === "de") {
      n = n.replace(",00", ".-"); // de
    }
  }

  if(showCurrency) {
    return `${Config.currency} ${n}`
  }
  else {
    return `${n}`
  }
}

export default {
  currency
}